import React from 'react';
import ProjektVerwaltung from './ProjektVerwaltung';

const Projekte = () => {
  return <ProjektVerwaltung />;
};

export default Projekte; 